import { render, staticRenderFns } from "./galeria.vue?vue&type=template&id=ad2cc9e8&scoped=true&"
import script from "./galeria.vue?vue&type=script&lang=js&"
export * from "./galeria.vue?vue&type=script&lang=js&"
import style0 from "./galeria.vue?vue&type=style&index=0&id=ad2cc9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2cc9e8",
  null
  
)

export default component.exports